/**
 * ProjectThreadPanel — the project-scoped conversation (Project lens).
 *
 * P3 MERGED LENS (2026-07-09): a THIN wrapper over the shared <LensThread/>.
 *
 *   BEFORE — it read List B only (`projects/{pid}/messages`), so its WhatsApp
 *            went STALE and it had no real 24-hour window.
 *   AFTER  — it merges List A (the live `wa_conversations` thread, correct 24h
 *            window, via the secure callables) with List B (this project's
 *            internal notes + email), in the REAL Team-Inbox <Thread/>. Strictly
 *            better: it GAINS the live WA thread + window and KEEPS notes+email.
 *
 * All three send paths remain: WhatsApp via the real <Composer/>, internal notes
 * via postMessage, email via sendEmail — through the Thread's channel switcher.
 *
 * Mounts in ProjectDetail's sticky desktop rail (`.project-comms-col`) and in the
 * mobile <ProjectCommsSheet>. In both, the reused `.ti-canvas` is the SOLE
 * scroller (no nested scrollbars — the desktop column is frame-locked in
 * LensThread.css).
 */
import LensThread from '../features/teaminbox/lens/LensThread';

interface ProjectThreadPanelProps {
  projectId: string;
  /** The linked client — the note/email contact target + empty copy. */
  clientId?: string;
  /** Optional client display name for the empty state. */
  clientName?: string;
}

export default function ProjectThreadPanel({
  projectId,
  clientId,
  clientName,
}: ProjectThreadPanelProps) {
  return (
    <LensThread
      mode="project"
      projectId={projectId}
      clientId={clientId}
      clientName={clientName}
    />
  );
}
